// extracted by mini-css-extract-plugin
export default {"priceContainer":"Hfa-z","discountedPrice":"Ifa-z","originalPrice":"Jfa-z","productPrice":"Kfa-z"};